import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import React from "react";
import SvgIconPikabu from "../util/SvgIconPikabu";
import SvgIconReddit from "../util/SvgIconReddit";
import SvgIconNUUM from "../util/SvgIconNUUM";

function AppTrash() {

    const xs = 12
    const sm = 4

    return (
        <>
            <Typography variant="h2" align="center">Корзина</Typography>
            <Typography align="center" mb={4}>Площадка повесила теневой бан, полностью заблокировала или больше не существует</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://pikabu.ru/@NanakiLucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.success.main}}>
                                        <SvgIconPikabu/>
                                    </Avatar>
                                }
                                title="Пикабу"
                                subheader="@NanakiLucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://www.reddit.com/user/isaev_space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconReddit/>
                                    </Avatar>
                                }
                                title="Reddit"
                                subheader="u/isaev_space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://nuum.ru/channel/isaev-space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconNUUM/>
                                    </Avatar>
                                }
                                title="NUUM"
                                subheader="@isaev-space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppTrash
